var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ab-ui-btn",class:[
    `ab-ui-btn--variant-${_vm.variant}`,
    { 'ab-ui-btn--block': _vm.block, 'ab-ui-btn--disabled': _vm.disabled },
    _vm.variant === 'primary' ? 'primary' : null
  ],attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.loading)?_c('span',{staticClass:"ab-ui-btn__loader"}):_vm._e(),_c('span',{staticClass:"ab-ui-btn__label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }